import { useMemo } from 'react';
import qs from 'query-string';
import config from 'config';

export const useShareUrl = (
  eventId?: string,
  eventShareToken?: string,
  ticketShareToken?: string
): string => useMemo(() => {
    if (!eventId || !ticketShareToken) {
return '';
}

    const params = qs.stringify({
      tierShareToken: ticketShareToken,
      invite: eventShareToken
    });

    return `${config.SITE_URL}events/${eventId}?${params}`;
  }, [eventId, eventShareToken, ticketShareToken]);
